import React from 'react';

export default function QuickReplyPicker(props) {
    const renderQuickReply = (reply, i) => {
        const body = reply.ReplyText
            .replace(/~(.*)~/, '<del>$1</del>')
            .replace(/_(.*)_/, '<em>$1</em>')
            .replace(/\*(.*)\*/, '<strong>$1</strong>')
            .replace(/```(.*)```/, '<code>$1</code>')
            .replace(/\n/g, '<br/>');

        return <li key={i} dangerouslySetInnerHTML={{__html: body}} onClick={props.cloneReply.bind(this, reply.ReplyText)}></li>
    }

    const textReplies = (props.quickReplies || []).filter(x => x.ReplyType === 'text')

    return (
        <ul className="quick-replies">
          {textReplies.map(renderQuickReply)}
        </ul>
    )
}
